import { toProperCase } from '@avalara/bat-apps-shared/helpers/index';
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { captureAbandonedSignup } from '../../../lib/helpers';
import { getCountries, getRegions } from '../../../lib/side-effects/avatax';
import { selectState } from '../../../selectors';
export const useAbandonedCart = (usingOfferFlow) => {
    const { data: { marketingData }, account: { isLoggedIn, billingContact, companyName: authenticatedCompanyName }, offer: { offerFlow }, sharedSignup: { signupForm }, system: { activeFlow }, } = useSelector(selectState);
    let authenticatedEmail;
    let authenticatedFirstName;
    let authenticatedLastName;
    let authenticatedAddress;
    let authenticatedCity;
    let authenticatedCountry;
    let authenticatedPostalCode;
    let authenticatedState;
    if (isLoggedIn && billingContact !== null && typeof billingContact !== 'string') {
        authenticatedEmail = billingContact.email || '';
        authenticatedFirstName = billingContact.firstName || '';
        authenticatedLastName = billingContact.lastName || '';
        authenticatedAddress = billingContact.street;
        authenticatedCity = billingContact.city;
        authenticatedCountry = billingContact.country;
        authenticatedPostalCode = billingContact.postalCode;
        authenticatedState = billingContact.state;
    }
    useEffect(() => {
        const abandonedSignupOptions = {
            company: {
                address: isLoggedIn ? authenticatedAddress : signupForm.street1,
                city: isLoggedIn ? authenticatedCity : signupForm.city,
                company_name: isLoggedIn ? authenticatedCompanyName : signupForm.companyName,
                country: isLoggedIn ? authenticatedCountry : signupForm.country,
                postal_code: isLoggedIn ? authenticatedPostalCode : signupForm.postalCode,
                state: isLoggedIn ? authenticatedState : signupForm.state,
            },
            email: isLoggedIn ? authenticatedEmail : signupForm.email,
            firstName: isLoggedIn ? authenticatedFirstName : signupForm.firstName,
            lastName: isLoggedIn ? authenticatedLastName : signupForm.lastName,
            marketingData,
        };
        let abandonedPurchaseHandler;
        if (usingOfferFlow) {
            if (!offerFlow)
                return () => { };
            abandonedPurchaseHandler = captureAbandonedSignup.bind(null, Object.assign(Object.assign({}, abandonedSignupOptions), { offerFlow,
                isLoggedIn }));
        }
        else {
            abandonedPurchaseHandler = captureAbandonedSignup.bind(null, Object.assign(Object.assign({}, abandonedSignupOptions), { activeFlow }));
        }
        window.addEventListener('unload', abandonedPurchaseHandler);
        return () => {
            window.removeEventListener('unload', abandonedPurchaseHandler);
        };
    }, [
        activeFlow,
        offerFlow,
        signupForm.firstName,
        signupForm.lastName,
        signupForm.companyName,
        signupForm.email,
        signupForm.street1,
        signupForm.city,
        signupForm.country,
        signupForm.postalCode,
        signupForm.state,
        marketingData.campaignId,
        marketingData.campaignName,
        marketingData.connector,
        marketingData.lsmr,
        marketingData.lso,
        marketingData.partnerSource,
        marketingData.salesRepId,
    ]);
};
export const useFetchRegionsAndCountries = (shouldFetchRegionsAndCountries = true) => {
    const { data: { countries, regions }, sharedSignup: { signupForm: { country } }, } = useSelector(selectState);
    const dispatch = useDispatch();
    useEffect(() => {
        if (shouldFetchRegionsAndCountries) {
            dispatch(getCountries());
            dispatch(getRegions(country));
        }
    }, [country]);
    const selectedCountryRegions = regions[country] || [];
    const formattedCountries = countries.map(({ code, name }) => ({ value: code, display: toProperCase(name) }));
    const formattedRegions = selectedCountryRegions.map(({ code, name }) => ({ value: code, display: toProperCase(name) }));
    return { formattedCountries, formattedRegions };
};
